import type { Tag } from '../types';

export const mockTags: Tag[] = [
  {
    id: 'tag-1',
    projectId: 'proj-1',
    name: 'Frontend',
    color: 'indigo-violet',
    createdAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'tag-2',
    projectId: 'proj-1',
    name: 'Backend',
    color: 'emerald-teal',
    createdAt: '2025-01-02T00:00:00Z',
  },
  {
    id: 'tag-3',
    projectId: 'proj-1',
    name: 'Bug',
    color: 'red-ember',
    createdAt: '2025-01-03T00:00:00Z',
  },
  {
    id: 'tag-4',
    projectId: 'proj-1',
    name: 'Design',
    color: 'pink-flamingo',
    createdAt: '2025-01-04T00:00:00Z',
  },
];
